export default function (Alpine) {
    Alpine.data(
        "fileUpload",
        function (
            uploadUrl = false,
            imageReferenceName = null,
            inputName = "file"
        ) {
            return {
                status: "none",
                uploadKey: null,
                fileName: null,
                downloadUrl: null,
                none: {
                    ["x-show"]() {
                        return this.status === "none"
                    },
                },
                ready: {
                    ["x-show"]() {
                        return this.status === "ready"
                    },
                },
                fileInput: {
                    "@change": function ($event) {
                        if ($event.target.files.length === 0) {
                            return
                        }

                        let file = $event.target.files[0]

                        this.status = "ready"
                        this.fileName = file.name
                        this.$dispatch("upload-ready", { name: file.name })

                        if (
                            imageReferenceName &&
                            this.$refs[imageReferenceName]
                        ) {
                            this.$nextTick(() => {
                                const fr = new FileReader()
                                fr.onload = () => {
                                    this.$refs[imageReferenceName].src =
                                        fr.result
                                }
                                fr.readAsDataURL(file)
                            })
                        }
                    },
                },
            }
        }
    )
}
